// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabs: {
      zIndex: theme.zIndex.modal,
      position: 'relative',
      marginTop: theme.spacing(1),
      '& div > span': {
        width: '100% !important',
        maxWidth: 152,
        margin: '0px 4px',
      },
      '& div > div:first-child > button': {
        '&:first-child': {
          borderRadius: '15px 15px 0px 0px',
          '& span:last-child': {
            background: '#292F36',
            left: -96,
          },
        },

        '&:last-child': {
          borderRadius: '15px 15px 0px 15px',
        },

        '& span:last-child': {
          opacity: 1,
          background: '#292F36',
          height: 22,
          minWidth: 48,
          width: '100%',
          borderRadius: 0,
          position: 'relative',
          top: 9,
          left: -120,
          zIndex: -1,
        },

        '& span:first-child': {
          position: 'relative',
          top: 12,
          zIndex: 1,
          paddingLeft: 12,
          paddingRight: 12,
        },
      },
    },
    tabSelected: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr',
      justifyContent: 'center',
      maxHeight: 54,
      padding: 0,

      color: '#fff !important',
      background: '#14171A',
      borderRadius: '15px 15px 0px 0px',
      opacity: 1,
      overflow: 'inherit',
      paddingTop: 0,
      paddingBottom: 0,
      '& + button': {
        '& span:last-child': {
          background: '#14171A !important',
        },
      },

      '& span:last-child': {
        opacity: 1,
        background: '#14171A !important',
        width: '100%',
        borderRadius: 0,
        position: 'relative',
        top: 9,
        left: -100,
        zIndex: -1,
      },
    },
    tab: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr',
      justifyContent: 'center',
      maxHeight: 54,
      padding: 0,

      color: '#4E5B66 !important',
      background: '#292F36',
      borderRadius: '15px 15px 15px 15px',
      opacity: 1,
      overflow: 'inherit',

      '&:first-child': {
        borderRadius: '15px 15px 15px 0px !important',
      },
    },
    middleTabSelected: {
      minWidth: 400,
      color: '#fff !important',
      background: '#14171A',
      borderRadius: '15px 15px 0px 0px',
      opacity: 1,
      overflow: 'inherit',
      paddingTop: 0,
      paddingBottom: 0,
      '& + button': {
        '& span:last-child': {
          background: '#14171A !important',
        },
      },

      '& span:last-child': {
        opacity: 1,
        background: '#14171A !important',
        width: '100%',
        borderRadius: 0,
        position: 'relative',
        top: 9,
        left: -100,
        zIndex: -1,
      },
    },
    middleTab: {
      minWidth: 400,
      color: '#4E5B66 !important',
      background: '#292F36',
      borderRadius: '15px 15px 0px 0px',
      opacity: 1,
      overflow: 'inherit',
    },
    lastTabSelected: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr',
      justifyContent: 'center',
      maxHeight: 54,
      padding: 0,

      width: '100%',
      margin: 0,
      maxWidth: 32,
      borderRadius: '15px 15px 15px 15px',
      background: '#fff',

      '& div': {
        opacity: 1,
        background: '#14171A !important',
        width: '100%',
        borderRadius: 0,
        position: 'relative',
        top: 20,
        left: -16,
        zIndex: -1,
      },
    },
    lastTab: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr',
      justifyContent: 'center',
      maxHeight: 54,
      padding: 0,

      width: '100%',
      margin: 0,
      maxWidth: 32,
      borderRadius: '15px 15px 15px 15px',
      background: '#fff',

      '& div': {
        opacity: 1,
        background: '#292F36 !important',
        width: '100%',
        borderRadius: 0,
        position: 'relative',
        top: 20,
        left: -16,
        zIndex: -1,
      },
    },
    PrittiLine: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 56,
      width: '100',
      padding: 5,
      borderRadius: 5,
      color: '#fff',
      marginRight: 6,
    },
    resume: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 70,
      minHeight: 42,
      height: '100%',

      marginRight: 5,
      padding: 7,
      border: '1px solid #14171A',
      borderRadius: 10,
    },
    contentImage: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 16,
      maxHeight: 16,
      height: '100%',
      marginRight: 5,
    },
  }),
);

export default useStyles;
